import { RoomMember } from 'matrix-js-sdk/src/matrix';
import { useTranslation } from 'react-i18next';

import { ReactComponent as Search } from 'assets/icons/Search.svg';

import InviteWorkspaceMemberItem from './InviteWorkspaceMemberItem';

interface WorkspaceMembersFieldProps {
  members: RoomMember[];
  invitees: string[];
  toggleInvitee: (memberId: string) => void;
}

const WorkspaceMembersField = ({ members, invitees, toggleInvitee }: WorkspaceMembersFieldProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-2">
      {members.length ? (
        members.map(({ userId, rawDisplayName }) => (
          <InviteWorkspaceMemberItem
            key={userId}
            name={rawDisplayName}
            isSelected={invitees.includes(userId)}
            onClick={() => toggleInvitee(userId)}
          />
        ))
      ) : (
        <div className="flex flex-col items-center justify-center py-2 gap-2">
          <Search className="stroke-1.5 h-5 w-5 shrink-0 stroke-black" />
          <span className="text-size-sm text-gray-80">{t('messenger.workspace_members_empty')}</span>
        </div>
      )}
    </div>
  );
};

export default WorkspaceMembersField;
